<template>
  <div class="sbu-filter-wrap">
    <div class="sbu-filter-container">
      <div v-for="(filter, index) in sbuFilters" :key="index">
        <md-radio :value="filter.value" :checked="filter.checked" @change="change">
          {{ filter.text }}</md-radio
        >
      </div>
    </div>
  </div>
</template>
<script>
import MdRadio from '@/components/MaterialRadio';
export default {
  props: {
    icsType: {
      type: String,
      default: '',
    },
    targetPage: {
      type: String,
      default: 'find',
    },
  },
  components: {
    MdRadio,
  },
  computed: {
    sbuFilters() {
      return [
        {
          value: '',
          checked: !this.icsType,
          text: this.targetPage === 'agent' ? this.$t('find.ALL_DEPT') : this.$t('main.ALL_USAGE'),
        },
        {
          value: 'i',
          checked: this.icsType === 'i',
          text: this.targetPage === 'agent' ? this.$t('main.MIDLAND_I') : this.$t('find.IND'),
        },
        {
          value: 'c',
          checked: this.icsType === 'c',
          text: this.targetPage === 'agent' ? this.$t('main.MIDLAND_C') : this.$t('find.COMM'),
        },
        {
          value: 's',
          checked: this.icsType === 's',
          text: this.targetPage === 'agent' ? this.$t('main.MIDLAND_S') : this.$t('find.SHOP'),
        },
      ];
    },
  },
  methods: {
    change(evt) {
      const filterKey = evt.target.value;
      if (this.icsType !== filterKey) {
        if (this.targetPage === 'find') {
          this.$emit('change', { buildingType: filterKey });
        } else if (this.targetPage === 'agent' || this.targetPage === 'transaction') {
          this.$emit('change', { icsType: filterKey });
        }
      }
    },
  },
};
</script>
<style scoped>
.sbu-filter-wrap {
  height: -webkit-fill-available;
  background: #f7f7f9;
  padding: 16px;
}

.sbu-filter-wrap >>> .md-radio label:before {
  border-radius: 2px;
  border: 1px solid #9a9a9a;
  width: 18px;
  height: 18px;
  transition: background 0.3s;
}
.sbu-filter-wrap >>> .md-radio label:after {
  transition: none;
}
.sbu-filter-wrap >>> .md-radio input[type='radio']:checked + label:before {
  background: #fee100;
  border: none;
}

.sbu-filter-wrap >>> .md-radio input[type='radio']:checked + label:after {
  transform: translate(0.25em, 0.33654em) rotate(-45deg);
  width: 0.75em;
  height: 0.375em;
  border: 0.125em solid #252525;
  border-top-style: none;
  border-right-style: none;
  left: 0;
  background: transparent;
  top: 0;
}

.sbu-filter-wrap >>> .md-radio label {
  margin-bottom: 0;
  font-size: 16px;
  line-height: 17px;
  font-weight: normal;
}

.sbu-filter-wrap >>> .md-radio label:before,
.sbu-filter-wrap >>> .md-radio label:after {
  border-radius: 2px;
  background: #ffffff;
}
/* laptop */
@media (min-width: 992px) and (max-width: 1199px) {
  .sbu-filter-container {
    max-width: 938px;
    margin: auto;
  }
}
</style>
